export default __webpack_public_path__ + "static/media/mechanicIcon.5fc56674.svg";